import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "container", "noResults"]

  search() {
    const searchTerm = this.inputTarget.value.toLowerCase().trim()
    let visibleCount = 0
    
    this.itemTargets.forEach(item => {
      const question = item.dataset.question

      if (searchTerm === '' || question.includes(searchTerm)) {
        item.classList.remove('hidden')
        visibleCount++
      } else {
        item.classList.add('hidden')
      }
    })

    // Show/hide "no results" message
    if (visibleCount === 0 && searchTerm !== '') {
      this.noResultsTarget.classList.remove('hidden')
    } else {
      this.noResultsTarget.classList.add('hidden')
    }
  }
}
